import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

function calculateClass(restProps) {
  var orientation = restProps.orientation,
      dashed = restProps.dashed,
      className = restProps.className;
  var direction = orientation === 'center' ? '' : "-".concat(orientation);
  return classNames('roo-divider roo-divider-horizontal', {
    'roo-divider-dashed': dashed
  }, dashed ? '' : "roo-divider-with-text".concat(direction), className);
}

var Divider = function Divider(_a) {
  var children = _a.children,
      restProps = __rest(_a, ["children"]);

  var className = restProps.className,
      style = restProps.style,
      type = restProps.type;

  if (type === 'vertical') {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('roo-divider roo-divider-vertical', className),
      style: style
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: calculateClass(restProps),
    style: style
  }, children ? /*#__PURE__*/React.createElement("span", {
    className: "roo-divider-text"
  }, children) : null);
};

Divider.defaultProps = {
  className: '',
  style: {},
  dashed: false,
  orientation: 'center',
  type: 'horizontal'
};
Divider.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  dashed: PropTypes.bool,
  orientation: PropTypes.oneOf(['left', 'center', 'right']),
  type: PropTypes.oneOf(['horizontal', 'vertical'])
};
export default Divider;